import { Component, ElementRef } from '@angular/core'
import { MbCheckoutShippingAddressFormBase } from '../mb-checkout-shipping-address-form-base'
import { ActivatedRoute } from '@angular/router'
import { EventService, GlobalMessageService, SiteConnector, WindowRef } from '@spartacus/core'
import { MbCheckoutCommonService } from '../../../../services/mb-checkout-common.service'
import { MbCheckoutStepService } from '../../../../services/mb-checkout-step.service'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MbCheckoutDeliveryFacade } from '../../../../facades/mb-checkout-delivery.facade'
import { MbCheckoutShippingFacade } from '../../../../facades/mb-checkout-shipping.facade'
import { checkoutValidationRules } from 'src/app/mb/shared/mb-constants'
import { BreakpointObserver } from '@angular/cdk/layout'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  selector: 'mb-checkout-new-shipping-address-form-us',
  templateUrl: './mb-checkout-new-shipping-address-form-us.component.html'
})
export class MbCheckoutNewShippingAddressFormUsComponent extends MbCheckoutShippingAddressFormBase {

  constructor (protected activatedRoute: ActivatedRoute,
               protected siteConnector: SiteConnector,
               protected mbCheckoutStepService: MbCheckoutStepService,
               protected mbCheckoutCommonService: MbCheckoutCommonService,
               protected mbCheckoutShippingFacade: MbCheckoutShippingFacade,
               protected globalMessageService: GlobalMessageService,
               protected mbCheckoutDeliveryService: MbCheckoutDeliveryFacade,
               protected activeCartService: ActiveCartFacade,
               protected winRef: WindowRef,
               protected el: ElementRef,
               protected breakpointObserver: BreakpointObserver,
               protected eventService: EventService) {
    super(activatedRoute,
      siteConnector,
      mbCheckoutStepService,
      mbCheckoutCommonService,
      mbCheckoutShippingFacade,
      globalMessageService,
      mbCheckoutDeliveryService,
      activeCartService,
      winRef,
      el,
      breakpointObserver,
      eventService
    )
  }

  override convertShippingAddressModel2Form (): UntypedFormGroup {
    return new UntypedFormGroup({
      companyName: new UntypedFormControl(this.shippingAddress?.companyName, [Validators.required,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)]),
      institute: new UntypedFormControl(this.shippingAddress?.institute,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      department: new UntypedFormControl(this.shippingAddress?.department,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      building: new UntypedFormControl(this.shippingAddress?.building,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      lab: new UntypedFormControl(this.shippingAddress?.lab, Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      streetInformation: new UntypedFormControl(this.shippingAddress?.streetInformation, [Validators.required,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)]),
      postalCode: new UntypedFormControl(this.shippingAddress?.postalCode, Validators.required),
      town: new UntypedFormControl(this.shippingAddress?.town, Validators.required),
      region: new UntypedFormControl(this.shippingAddress?.region, Validators.required),
      country: new UntypedFormControl(this.isCountryDisabled(), Validators.required),
      id: new UntypedFormControl(this.shippingAddress?.id)
    })
  }

  override convertShippingAddressForm2Model (): void {
    this.shippingAddress = {
      ...this.shippingAddress,
      companyName: this.shippingAddressForm.get(this.constants.COMPANY_CODE)?.value,
      institute: this.shippingAddressForm.get(this.constants.INSTITUTE_CODE)?.value,
      department: this.shippingAddressForm.get(this.constants.DEPARTMENT_CODE)?.value,
      building: this.shippingAddressForm.get(this.constants.BUILDING_CODE)?.value,
      lab: this.shippingAddressForm.get(this.constants.LAB_CODE)?.value,
      streetInformation: this.shippingAddressForm.get(this.constants.STREET_INFORMATION)?.value,
      postalCode: this.shippingAddressForm.get(this.constants.POSTAL_CODE_CODE)?.value,
      town: this.shippingAddressForm.get(this.constants.TOWN_CODE)?.value,
      region: this.shippingAddressForm.get(this.constants.REGION_CODE)?.value,
      country: this.country,
      id: this.shippingAddressForm.get(this.constants.ID_LOWER_CASE)?.value
    }
  }
}
